import WS from "../../../../utility/webSocket";
import ApiIntegrationEconomic from "@/api/integration/economic"
import errorDialog from "@/views/ErrorDialog/errorDialog"
import Model from "./model"
import { $t } from "@/i18n";

export default class Controller {
    constructor(selectedCompanyId, onImportDone) {
        this.model = new Model(selectedCompanyId)
        this.onImportDone = onImportDone
        this.constructWS()
    }

    constructWS() {
        this.webSocket = new WS(this.onMessage.bind(this), "/ws/import")
    }

    onMessage(data) {
        this.model.setImportReady(data.import_session_id)
        this.webSocket.close()
        this.onImportDone(data.import_session_id)
    }

    startImport = (onDone = null) => {
        let self = this

        this.webSocket.connect(async () => {
            self.model.startImport()
            if (onDone) {
                await onDone()
            }
        }, () => {
            errorDialog.showError($t("Failed to connect to server"))
            if (onDone) {
                onDone()
            }
        })
    }

    importAgain() {
        this.model.importAgain()
    }

    setAgreementToken(value) {
        this.model.setAgreementToken(value)
    }

    handleShowConnect() {
        this.model.showConnect()
    }

    async loadState(showConnect) {
        await this.model.loader.withLoader(async () => {
            let state = await ApiIntegrationEconomic.getState(this.model.getSelectedCompanyId())

            if (state.token) {
                this.model.setAgreementToken(state.token)
            }

            if (showConnect) {
                this.model.showConnect()
            } else if (state.token) {
                this.model.importAgain()
            } else {
                this.model.showConnect()
            }
        })
    }

    async handleSave() {
        await this.model.loader.withLoader(async () => {
            try {
                await ApiIntegrationEconomic.testConnection(this.model.getSelectedCompanyId(), this.model.getAgreementToken())
                this.model.importAgain()
            } catch (ex) {
                errorDialog.showError(ex)
            }
        })
    }

    async handleStartImport() {
        await this.model.loader.withLoader(async () => {
            this.startImport(async () => {
                try {
                    await ApiIntegrationEconomic.startImport(this.model.getSelectedCompanyId())
                } catch (ex) {
                    errorDialog.showError(ex)
                    this.model.loader.setForceLoading(false);
                    this.webSocket.close()
                    // ability to reconnect if the first API call ended up in error response
                    this.constructWS()
                }
            })
        })
    }
}